import React from 'react'
import { string, array } from 'prop-types'
import classNames from 'classnames'

import Container from 'Primitive/Container'
import Type from 'Primitive/Type'
import BlockText from 'Common/BlockText'
import Diagram from 'Common/Diagram'

import styles from './GoCashless.module.scss'
import RoundedOverlay from 'Common/RoundedOverlay'
import { useTranslation } from 'react-i18next'

const GoCashless = ({ title, description }) => {
  const { t } = useTranslation()

  return (
    <Container size="full" className={styles.Main}>
      <RoundedOverlay className={styles.RoundedOverlay} />
      <Container
        gutter
        size="wide"
        center
        spacious
        className={styles.GoCashless}
      >
        <Type size="displayLarge" as="h3" className={styles.Title}>
          {title}
        </Type>
        {description && (
          <div className={styles.Description}>
            <BlockText blocks={description} size="baseLarge" />
          </div>
        )}
        <div className={styles.Wrapper}>
          <div className={styles.DiagramWrapper}>
            <Diagram />
            <div className={styles.Labels}>
              <Type
                size="displayTiny"
                className={classNames(styles.Label, styles.Ordering)}
              >
                {t('goCashless.ordering')}
              </Type>
              <Type
                size="displayTiny"
                className={classNames(styles.Label, styles.Processing)}
              >
                {t('goCashless.processing')}
              </Type>
              <Type
                size="displayTiny"
                className={classNames(styles.Label, styles.Payment)}
              >
                {t('goCashless.payment')}
              </Type>
              <Type
                size="displayTiny"
                className={classNames(styles.Label, styles.Service)}
              >
                {t('goCashless.service')}
              </Type>
            </div>
          </div>
          <div className={styles.TimesFaster}>
            <Type size="displayLarge">3X</Type>
            <Type className={styles.FasterText} size="displaySmall">
              {t('goCashless.faster')}
            </Type>
          </div>
        </div>
      </Container>
    </Container>
  )
}

GoCashless.propTypes = {
  title: string,
  description: array
}

export default GoCashless
